import Vue from 'vue'
import axios from 'axios'

const state = {
    programcategories: [],
    programcategoriesFetched: false,
}

function findById(id, arr)
{
    for (let i = 0; i < arr.length; ++i)
    {
        if (arr[i].id === id)
        {
            return { index: i, obj: arr[i]}
        }
    }
    return null
}

const mutations = {

    'PROGRAMCAT_FETCH' (state, list)
    {
        state.programcategories = list
        state.programcategoriesFetched = true
    },

    'PROGRAMCAT_ADD' (state, model)
    {
        state.programcategories.push(model)
    },

    'PROGRAMCAT_DELETE' (state, model)
    {
        const result = findById(model.id, state.programcategories)
        if (result)
        {
            state.programcategories.splice(result.index, 1)
        }
    },

    'PROGRAMCAT_UPDATE' (state, model)
    {
        const result = findById(model.id, state.programcategories)
        if (result)
        {
            Vue.set(state.programcategories, result.index, model)
        }
    },

}

const actions = {

    init({rootGetters, dispatch})
    {
        if (rootGetters.authLoggedIn)
            dispatch('programcatCheck')
    },

    programcatCheck({dispatch, state})
    {
        if (!state.programcategoriesFetched)
        {
            dispatch('programcatFetch')
        }
    },

    programcatFetch({commit})
    {
        return new Promise(async(resolve, reject) => {
            const list = await axios.get(process.env.API_URL + '/v1/admin/programcategories')
            if (list)
            {
                commit('PROGRAMCAT_FETCH', list.data)
                resolve(list.data)
            } else {
                reject()
            }
        })
    },

    programcatUpdate({commit}, model)
    {
        return new Promise((resolve, reject) => {
            commit('PROGRAMCAT_UPDATE', model)
            resolve()
        })
    },

    programcatDelete({commit}, model)
    {
        return new Promise((resolve, reject) => {
            commit('PROGRAMCAT_DELETE', model)
            resolve()
        })
    },

    programcatNew({commit}, model)
    {
        return new Promise((resolve, reject) => {
            commit('PROGRAMCAT_ADD', model)
            resolve()
        })
    },

}

const getters = {
    programcategoriesList: state => JSON.parse(JSON.stringify(state.programcategories))
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/programcategories.js